import "../../../styles/kjedeweb/menu.scss";

import Icon, { iconColor, iconTypes } from "../../common/components/Icon.jsx";
import { Localization, createLocalization } from "../../common/util/localization.jsx";
import { logOut, stopImpersonating } from "../../common/actions/authentication.js";

import DropDownMenu from "../../common/components/DropDownMenu.jsx";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import React from "react";
import { connect } from "react-redux";
import { setModal } from "../../common/actions/modal";
import { withRouter } from "react-router-dom";

class HubMenuDropdownItem extends React.PureComponent {
    render() {
        const {
            icon,
            label,
            onClick
        } = this.props;
        return (
            <div className="dropdown-menu-item" onClick={onClick}>
                <Icon type={icon} className="dropdown-menu-item-icon" />
                <div className={"dropdown-menu-item-text noselect"} >
                    {label}
                </div>
            </div>
        );
    }
}

HubMenuDropdownItem.propTypes = {
    icon: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    onClick: PropTypes.func
};


class HubMenuItem extends React.PureComponent {
    constructor(props) {
        super(props);

        this.onClick = this.onClick.bind(this);
    }
    onClick(e) {
        this.props.onClick(e, this.props.name);
    }
    render() {
        const {
            activeMenu,
            children,
            dropDownStyle,
            icon,
            name,
            side,
            number
        } = this.props;
        const isActive = activeMenu === name;
        const className = `top_bar_item ${side} ${isActive ? "active_icon" : ""}`;
        const currentColor = isActive ? iconColor.white : null;
        return (
            <React.Fragment>
                <div className={className} onClick={this.onClick}>
                    <div className="item item-icon notifications_icon">
                        <Icon type={icon} className="menu_icon noselect" color={currentColor} />
                        {number && (
                            <small>{number}</small>
                        )}
                    </div>
                    {isActive && (
                        <DropDownMenu onClickOutside={this.onClick} style={dropDownStyle}>
                            {children}
                        </DropDownMenu>
                    )}
                </div>
            </React.Fragment>
        );
    }
}

HubMenuItem.propTypes = {
    activeMenu: PropTypes.string,
    children: PropTypes.node,
    dropDownStyle: PropTypes.object,
    icon: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    number: PropTypes.number,
    onClick: PropTypes.func.isRequired,
    side: PropTypes.string.isRequired
};

const mapStateToProps = () => {
    return state => {
        return {
            hubUser: state.authentication.email,
            deviceType: state.view.deviceType,
            innerWidth: state.view.innerWidth,
            isImpersonated: state.authentication.isImpersonated,
            localization: createLocalization(state),
            view: state.view,
        };
    };
};

const mapDispatchToProps = {
    logOut,
    setModal,
    stopImpersonating
};

class HubMenu extends React.PureComponent {
    constructor(props) {
        super(props);

        this.state = {
            menu: null
        };

        this.onClick = this.onClick.bind(this);
        this.onClickLogout = this.onClickLogout.bind(this);
        this.onClickAccountAndSettings = this.onClickAccountAndSettings.bind(this);
        this.onClickStopImpersonating = this.onClickStopImpersonating.bind(this);
    }

    UNSAFE_componentWillMount() {
    }

    onClick(e, whatMenu) {
        if (e) {
            e.preventDefault();
            e.stopPropagation();
        }

        if (whatMenu !== this.state.menu) {
            this.setState({ menu: whatMenu });
        } else {
            this.setState({ menu: null });
        }
    }
    onClickLogout() {
        const {
            history,
            logOut
        } = this.props;
        logOut(history, "Logged out");
    }

    onClickAccountAndSettings(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.history.push("/account_settings");
        this.setState({ menu: null });
    }

    onClickStopImpersonating(e) {
        e.preventDefault();
        e.stopPropagation();

        this.props.stopImpersonating(this.props.history);
    }

    render() {
        const {
            localization,
        } = this.props;

        const path = this.props.location.pathname;
        const links = [
            {
                url: "/overview",
                urlTest: "/overview",
                label: localization.text("hubMenu", "overview")
            }, {
                url: "/production",
                urlTest: "/production",
                label: localization.text("hubMenu", "production")
            },
        ];
        const components = [];
        for (let i = 0; i < links.length; i++) {
            components[components.length] = (<div className={`top_bar_item left ${path.startsWith(links[i].urlTest, 0) ? "active" : ""}`} key={i}>
                <Link className="item" to={links[i].url} >{links[i].label}</Link>
            </div>);
        }

        return (
            <div className="top_body">
                <div id="top_bar">
                    <React.Fragment>
                        <div className="top_bar_item user-card">
                            <div className="chainwelcome-text"><Icon type={iconTypes.account} className="chainmenu_icon" /> {this.props.hubUser}</div>
                        </div>
                        {(this.props.isImpersonated) && (
                            <div className="top_bar_item">
                                <button className="btn" onClick={this.onClickStopImpersonating}>{localization.text("dashboard", "changeBackCustomer")}</button>
                            </div>
                        )}
                        <div className="top_bar_item right" onClick={this.onClickLogout}>
                            <div className="item item-icon"><Icon type={iconTypes.logout} className="menu_icon" /></div>
                        </div>
                    </React.Fragment>
                </div>
            </div>
        );
    }
}
HubMenu.propTypes = {
    hubUser: PropTypes.string.isRequired,
    deviceType: PropTypes.string,
    history: PropTypes.object,
    innerWidth: PropTypes.number.isRequired,
    isImpersonated: PropTypes.bool,
    location: PropTypes.object,
    localization: Localization.propTypes.isRequired,
    logOut: PropTypes.func.isRequired,
    setModal: PropTypes.func.isRequired,
    stopImpersonating: PropTypes.func.isRequired,
    view: PropTypes.object,
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(HubMenu));
